export default __webpack_public_path__ + "static/media/frango_yin_yang.2aaa0445.jpg";